import { RouteType } from "../../../types/RouteType";
import { POConversionViewStore } from "./stores/POConversionViewStore";
import RootStore from "../../../stores/RootStore";

const POConversionRoute: RouteType = {
  name: "PO To Invoice",
  path: "/accounting/po-conversion",
  layout: "/app",
  requiresAuth: true,
  hidden: true,
  requiresAdmin: false,
  requiresPermission: false,
  group: "Accounting",

  viewportCard: {
    header: {
      component: () => import("./components/POConversionHeader"),
      title: "PO to Invoice",
      color: "primary",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./components/POConversionWorkflow"),
      grayBackground: true,
    },
  },

  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Load required data
    try {
      // Load purchase orders
      await (rootStore as any).purchaseOrdersStore.find({
        // query: {
        //   status: { $in: ['Approved', 'Received'] },
        //   convertedToInvoice: false
        // }
      });

      // Load purchase order line items
      if ((rootStore as any).purchaseOrderLineItemsStore) {
        await (rootStore as any).purchaseOrderLineItemsStore.find({});
      }

      // In demo environment, just load all users without filtering by permissions
      // since the permissions column doesn't exist
      if ((rootStore as any).userStore) {
        await (rootStore as any).userStore.find({});
      }
    } catch (error) {
      console.error("Error loading data for PO conversion:", error);
    }

    return true;
  },

  beforeExit: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any)
      .poConversionViewStore as POConversionViewStore;

    // Don't prompt if conversion was successful (user is being redirected to invoice)
    if (store.conversionSuccess) {
      return true;
    }

    // Check for unsaved changes
    if (store.isDirty && store.selectedPOId) {
      const confirm = window.confirm(
        "You have unsaved changes in your PO conversion. Do you want to save a draft before leaving?"
      );
      if (confirm) {
        await store.saveDraft();
      }
    }
    return true;
  },

  onExit: ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any)
      .poConversionViewStore as POConversionViewStore;
    store.reset();
  },

  dialogs: [
    {
      name: "PO Preview",
      component: () => import("./dialogs/POPreviewDialog"),
      title: "Purchase Order Details",
      height: 600,
      cancelButton: true,
    },
  ],
};

export default POConversionRoute;
